/** Max size per file for correspondence register / thread entry attachments. */
export const CORRESPONDENCE_MAX_ATTACHMENT_MB = 75;
export const CORRESPONDENCE_MAX_ATTACHMENT_BYTES = CORRESPONDENCE_MAX_ATTACHMENT_MB * 1024 * 1024;

export const correspondenceMaxSizeLabel = () => `${CORRESPONDENCE_MAX_ATTACHMENT_MB} MB`;
